import { DriverDeliveries } from "modules/financial";

const DriverDeliveriesPage = () => {
  return <DriverDeliveries />;
};

export default DriverDeliveriesPage;
